import React, { FC } from 'react';
import { TCHHomeProductDashSeriesSolutions, TCHHomeProductDashSeriesItem } from '../../../types/productDashboard.types';
import RoutableNotEditableLink from '../../../../@shared/routableNotEditableLink';

export type TProductSolutionBadgeProps = {
  data: TCHHomeProductDashSeriesItem;
  cardType: string;
  linkUrl?: string;
};

const SolutionBadge: FC<TProductSolutionBadgeProps & TCHHomeProductDashSeriesSolutions> = (props) => {
  const { data, cardType, linkUrl } = props;
  const isSeriesCardType = cardType === 'series';
  const solutionBadge = isSeriesCardType ? data?.solutionsSeries : data?.solutionsModel;

  return (
    <div className="product-dashboard-card__image--card-label-wrapper">
      {solutionBadge?.map((badgeItem, idx) => {
        return (
          <div key={`product-badge-${idx}`} className="product-dashboard-card__image--card-label">
            <RoutableNotEditableLink href={linkUrl}>{badgeItem?.badge}</RoutableNotEditableLink>
          </div>
        );
      })}
    </div>
  );
};

export default React.memo(SolutionBadge);
